import React, { useState, useEffect } from 'react';
import './Login.css';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import logoIcam from '../../static/img/1200px-logo-icam---2008-1-43@2x.png';
import { useAuth } from '../../context/AuthContext';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const history = useHistory();
  const { login, isAuthenticated } = useAuth();

  // ðŸ”„ Rediriger si déjà  connecté
  useEffect(() => {
    console.log("Login - Vérification authentification:", isAuthenticated);
    if (isAuthenticated) {
      console.log("Déjà  authentifié â†’ redirection /home");
      history.push('/home');
    }
  }, [isAuthenticated, history]);


  // ðŸ” Traitement du Login
  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      if (!process.env.REACT_APP_API_URL) {
        throw new Error('API URL is not defined');
      }

      console.log("Tentative connexion avec:", username);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/login`,
        { username, password },
        {
          headers: {
            'Content-Type': 'application/json',
            'ngrok-skip-browser-warning': 'true',
          },
        }
      );

      console.log('Réponse login:', response.data);

      // âœ” Détecter rà´le administrateur
      const isAdmin = response.data?.is_admin || false;

      // ðŸ”‘ Récupérer token dans tous les cas possibles
      const token =
        response.data?.access_token ||
        response.data?.token ||
        response.data?.jwt ||
        response.data?.authToken ||
        response.data?.user?.token ||
        null;

      if (!token) {
        console.error("âŒ Aucun token trouvé dans la réponse !");
        setError("Erreur : aucun token renvoyé par le serveur.");
        setIsLoading(false);
        return;
      }

      // âœ” Stockage du token
      localStorage.setItem("token", token);
      console.log("ðŸ” Token stocké :", token);


      // ï¿½ï¿½ âœ” Stockage userId et enterpriseId
      if (response.data?.user) {
        if (response.data.user.id) {
          localStorage.setItem("userId", response.data.user.id);
          console.log("ðŸ‘¤ userId stocké :", response.data.user.id);
        }

        if (response.data.user.enterpriseId) {
          localStorage.setItem("enterpriseId", response.data.user.enterpriseId);
          console.log("ðŸ¢ enterpriseId stocké :", response.data.user.enterpriseId);
        }
      } else {
        console.warn("âš  Aucun userId / enterpriseId renvoyé par l'API !");
      }


      // âœ” Stockage infos auth
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("isAdmin", isAdmin.toString());
      localStorage.setItem("username", username);

      // âœ” Mise à  jour du contexte global
      login(isAdmin);
      console.log("âœ” Connexion réussie, état auth mis à  jour");


      // ðŸ” Redirection selon rà´le
      setTimeout(() => {
        if (isAdmin) {
          window.location.href = "/admin";
        } else {
          window.location.href = "/home";
        }
      }, 100);

    } catch (error) {
      console.error("Erreur login:", error);

      if (error.response) {
        setError(
          `Error ${error.response.status}: ${error.response.data.detail || "Invalid username or password"}`
        );
      } else if (error.request) {
        setError("Server not responding. Check connection or backend status.");
      } else {
        setError(error.message || "Error during login.");
      }

    } finally {
      setIsLoading(false);
    }
  };


  // Navigation vers signup
  const navigateToRegister = () => {
    history.push('/inscription');
  };


  // ðŸ–¥ï¸ UI
  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-left">
          <div className="login-logo-container">
            <img src={logoIcam} alt="ICAM Logo" className="login-logo" />
          </div>

          <h2 className="login-welcome">Welcome to the Supply Chain Platform</h2>
          <p className="login-description">
            Log in to access your personal space and manage your projects.
          </p>
        </div>

        <div className="login-right">
          <div className="login-form-container">
            <h1 className="login-title">Login</h1>

            {error && <div className="login-error">{error}</div>}

            <form onSubmit={handleLogin} className="login-form">
              <div className="login-input-group">
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  placeholder="Enter your username"
                />
              </div>

              <div className="login-input-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="Enter your password"
                />
              </div>

              <button type="submit" className="login-button" disabled={isLoading}>
                {isLoading ? "Logging in..." : "Login"}
              </button>
            </form>

            <div className="login-footer">
              <p>Don't have an account?</p>
              <button
                type="button"
                onClick={navigateToRegister}
                className="register-link"
              >
                Register
              </button>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
}

export default Login;

